/** Browser/Node-neutral base64 helpers (no Node builtins in the browser surface). */
export function encodeBase64(value) {
    if (typeof btoa === 'function')
        return btoa(value);
    throw new Error('base64 encoding is not available in this environment');
}
export function decodeBase64UrlUtf8(value) {
    const normalized = value.replace(/-/g, '+').replace(/_/g, '/');
    const padded = normalized + '='.repeat((4 - (normalized.length % 4)) % 4);
    if (typeof atob !== 'function')
        throw new Error('base64 decoding is not available in this environment');
    const binary = atob(padded);
    const bytes = new Uint8Array(binary.length);
    for (let index = 0; index < binary.length; index += 1)
        bytes[index] = binary.charCodeAt(index);
    return new TextDecoder().decode(bytes);
}
//# sourceMappingURL=base64.js.map